import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes, data is still valid but not up to date so we don't refetch it
      gcTime: 10 * 60 * 1000, // 10 minutes, data is garbage collected after 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
